import { Star } from "lucide-react"

interface StarRatingProps {
    rating: number
    editable?: boolean
    onChange?: (rating: number) => void
}

export const StarRating = ({ rating, editable, onChange }: StarRatingProps) => {
    return (
        <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
                <button
                    key={star}
                    type="button"
                    disabled={!editable}
                    onClick={() => onChange?.(star)}
                    className={`transition-all duration-200 ${star <= rating ? "text-yellow-400" : "text-gray-200"
                        } ${editable ? "cursor-pointer hover:scale-110" : "cursor-default"}`}
                >
                    <Star className={`h-5 w-5 ${star <= rating ? "text-yellow-400 fill-yellow-400" : "text-gray-200"}`} />
                </button>
            ))}
        </div>
    )
}
